/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TypesOfActions {
  Create = 0,
  Update = 1,
  Delete = 2,
}
